/* Emotion removes unknown props from the DOM only for string tags such as styled.div. With a
 * component target it forwards every prop, and MUI FormControl puts unknown props on its root
 * element, where React reports an unknown attribute. Use this helper for a boolean prop, because
 * it keeps the boolean type. A lowercase string prop is the other option. */
export const transientProps = (...names: string[]) => ({
  shouldForwardProp: (prop: string) => !names.includes(prop)
})
